// Tiny event bus so the (non-React) response handler can signal the UI to show
// the "upgrade required" plate when the API returns 402/403 for the user token.
const EVENT = 'bq:upgrade-required'

export const emitUpgradeRequired = (url: string) =>
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { url } }))

export const onUpgradeRequired = (cb: (url: string) => void) => {
    const handler = (e: Event) => cb((e as CustomEvent<{ url: string }>).detail.url)
    window.addEventListener(EVENT, handler)
    return () => window.removeEventListener(EVENT, handler)
}
